import Env from '../base/env'
import Channels from '../base/channels'
import raf from 'raf'

export default class Splashscreen
{
    constructor(view,_transform=false)
    {
        this.view = view
        this.$mask = this.view.querySelector('.jsMask')
        this.$bg = this.view.querySelector('.jsImage')
        this.$text = this.view.querySelector('.jsText')
        this.getScrollTop = 0;
        this.offsetView = 1
        this.raf = undefined
        this.funcUnlocked = this.unlocked.bind(this)
        this.TRANSFORM_MODE = _transform;
        this.LOCKED = true
        this.init()
    }

    actions()
    {
        this.checkTopPosition()
        this.hideMask()
    }

    checkTopPosition()
    {
        if(this.TRANSFORM_MODE == true)
        {
            var getValue = parseInt(this.view.closest('.layout').css('transform').split(',')[5]);
            if(isNaN(getValue) == false)
            {
                this.getScrollTop = getValue
            }
            else
            {
                this.getScrollTop = 0
            }
        }
        else
        {
            this.getScrollTop = Env.framework.toolbox.scrollPosition().scrollY
        }
    }

    destroy()
    {
        raf.cancel(this.raf)
        Channels.removeListener('coverintro::done',this.funcUnlocked)
    }

    events()
    {
        Channels.on('coverintro::done',this.funcUnlocked)
    }

    hideMask()
    {
        const context = Env.framework.toolbox.getViewport().height * this.offsetView
        const ratio = this.getScrollTop / context
        let ratioAlpha = Math.abs(this.getScrollTop) / context
        let alphaValue = ratioAlpha
        const yPosImage = (ratio * -1000) / 3
        const yPosText = (ratio * -200) / 2

        if(alphaValue < 0)
        {
            alphaValue = 0
        }
        else if(alphaValue > 1)
        {
            alphaValue = 1
        }

        if(ratioAlpha > 1) ratioAlpha = 1

        if(this.$mask != null)
        {
            this.$mask.style.opacity = alphaValue
        }
        if(this.$bg != null && this.LOCKED == false)
        {
            TweenLite.set(this.$bg,{ y : yPosImage })
        }
        if(this.$text != null)
        {
            this.$text.style.transform = `translateY(${yPosText}%)`
        }

        if(ratio < .9) {
            if(Env.$html.classList.contains('splashscreen--isIn') == false) {
                Env.$html.classList.add('splashscreen--isIn')
            }
        } else {
            if(Env.$html.classList.contains('splashscreen--isIn') == true) {
                Env.$html.classList.remove('splashscreen--isIn')
            }
        }

    }

    init()
    {
        if(Env.tablet == true || Env.phone == true) return false;
        this.events()
        this.watcher()
    }

    unlocked()
    {
        this.LOCKED = false
    }

    watcher()
    {
        this.raf = raf(()=>{
            this.watcher()
        })
        this.actions()
    }
}


// WEBPACK FOOTER //
// ./resources/js/fx/Splashscreen.js